<template>
    <div id="MainSection" v-inview:animate="'fadeIn'">
      <v-container class="p-0" fluid>
        <v-row no-gutters>
          <v-col cols="12" class="mb-4 mt-11">
            <v-item-group>
              <v-row no-gutters>
                <v-col
                  v-for="(item, i) in items"
                  :key="i"
                  cols="12"
                >
                  <v-card
                    tile
                    outlined
                  >
                    <div class="d-flex flex-no-wrap justify-space-between">
                      <div>
                        <v-avatar
                          class="ma-3"
                          size="94"
                          tile
                        >
                          <v-img :src="item.src"></v-img>
                        </v-avatar>
                      </div>
                      <div style="display: contents">
                        <v-card-title
                          class="headline p-0"
                          v-html="renderLineBreak(`${item.title}`)"
                        >
                        </v-card-title>
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </v-item-group>
          </v-col>
        </v-row>
      </v-container>
  </div>
</template>

<script>

export default {
  name: 'MainSection',
  components: {
  },
  data() {
    return {
      items: [
        {
          title: '매장으로 고객<br/>홍보물을 보내드려요!',
          src: require('@/assets/images/todaystore/ic-ic-tr-gift.svg'),
        },
        {
          title: '매주 고객 이벤트를<br/>제공해 드려요!',
          src: require('@/assets/images/todaystore/ic-ic-tr-event.svg',)
        },
        {
          title: '재방문을 위한<br/>문자도 발송해 드려요!',
          src: require('@/assets/images/todaystore/ic-tr-message.svg'),
        },
      ]
    }
  },
  methods: {
    renderLineBreak(text) {
      return `<span> ${text} </span>`
    }
  }
}
</script>
<style lang="scss" scoped>
  #MainSection {
    padding-left: 7.82vw;
    padding-right: 7.82vw;
    h4 {
      background-color: #f4faff;
    }
    .v-card {
      border: none;
      margin-bottom: 3.299vh;
      &__title {
        font-size: 1.13rem;
        font-weight: 800;
        line-height: 1.44;
        margin-left: 1.38rem;
      }
      img {
        width: 94px;
        height: 94px;
      }
    }
  }
</style>
